<template>
  <div id="app">
    <app-navigation
      :locale="locale"
      v-on:locale="updateLocale"
    ></app-navigation>
    <div v-if="0" class="test">
      O: {{ orientation }} -- {{ screenWidth }} -- {{clientWidth}}
    </div>
    <!-- moved :style="customStyle" to Renderer.vue to have bg image only for poll-->
    <div class="content-area">
      <router-view />
    </div>

    <app-footer v-if="false"></app-footer>
    <cookie-law
      theme="Kulibri"
      buttonText="OK"
      :message="consentMessage"
    ></cookie-law>
  </div>
</template>

<script>
import Navigation from '@/components/UI/Navigation.vue';
import Footer from '@/components/Footer.vue';
import { deviceMixin } from '@/components/mixins/DeviceMixins';

import CookieLaw from 'vue-cookie-law';
import { constants } from '@/shared/constant';

export default {
  mixins: [deviceMixin],

  data() {
    return {
      clientWidth: 0,
      screenWidth: 0,
      orientation: 0
    };
  },

  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
    },

    updateScreenValues() {
      this.screenWidth = screen.width;
      this.orientation = screen.orientation ? window.orientation : window.orientation
      this.clientWidth = this.getClientWidth();
    },


    getClientWidth() {
      let clientWidth = screen.width;
      if (this.isIOSDevice &&  this.orientation && this.orientation != 0) {
        clientWidth = screen.height;
      }
      return clientWidth;
    },

    // isLandscape() {
    //   if (!this.isMobileDevice) return false;
    //   //console.log("isLandscape:", );
    //   if (window.innerWidth > window.innerHeight) return true;
    //   return false;
    // },


    orientationHandler() {
      this.updateScreenValues();
      //const  clientWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;

      if (this.clientWidth < constants.mobileBreakpoint) {
        console.log('Resize <  breakpoint');
        this.$store.commit('setMobileView', true);

        if (!this.isMobileView) {
          const viewportContent = 'width=device-width initial-scale=0.8 maximum-scale=1.0';
          document
            .querySelector("meta[name='viewport']")
            .setAttribute('content', viewportContent);
        }
      } else {
        console.log('Resize > breakpoint');
        this.$store.commit('setMobileView', false);
        const viewportContent = 'width=device-width initial-scale=1.0';
        document
          .querySelector("meta[name='viewport']")
          .setAttribute('content', viewportContent);

      }
    },
  },

  computed: {
    auth() {
      return this.$store.getters.isAuthenticated;
    },

    consentMessage() {
      return this.$t('warnings.cookie-consent');
    },

    bgauth() {
      return this.$store.getters.isAuthenticated;
    },

    locale() {
      return this.$i18n.locale;
    },
    customStyle() {
      console.log('fullpath:', this.$route.fullPath);
      if (this.$route.fullPath == '/') {
        return '';
      }
      if (this.$store.getters.bgImage) {
        let bgImage = this.$store.getters.bgImage.url;
        let bgStyle = `background-image: url('${bgImage}')`;
        console.log('%c bgStyle:', 'color:red', bgStyle);
        return bgStyle;
      } else {
        return '';
      }
    },
  },

  mounted() {
    //window.addEventListener('resize', this.resizeHandler);
    window.addEventListener('orientationchange', this.orientationHandler, false);

    //const mobileDevice = this.deviceWidth < constants.mobileBreakpoint;
    this.$store.commit('setMobileDevice', this.isMobileDevice);
    this.orientationHandler();
  },

  beforeCreate() {
    this.$store.dispatch('tryAutoLogin', this.$i18n);
    this.$store.dispatch('initCsrf');
  },

  components: {
    'app-navigation': Navigation,
    'app-footer': Footer,
    CookieLaw,
  },
};
</script>

<style lang="scss">
@import '@/styles/colors.scss';

.Cookie {
  z-index: 42000;
}

.Cookie > * {
  margin: 0.2375rem 0;
  -ms-flex-item-align: center;
  align-self: center;
}

.Cookie--Kulibri {
  background: $primary;
  color: #fff;
  padding: 1.25em;
  z-index: 42000 !important;

  .Cookie__button {
    border-radius: 0.2 rem;
  }

  .Cookie__buttom {
    background: red;
    justify-content: center;
    text-align: center;
  }

  .Cookie__content {
    justify-content: center;
    text-align: center;
    width: 100%;
  }

  .Cookie__button {
    background: white;
    padding: 0.1em 1.125em;
    color: $primary;
    border-radius: 0.2rem;
    border: 0;
    font-size: 1em;
  }
}

#app {
  //font-family: 'Open Sans', sans-serif;
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  overflow-y: hidden;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.sidepanel-body {
  color: rgb(29, 29, 29);
  font-size: 14px;
  width: 100%;
  padding: 16px;
  label {
    margin-bottom: 0px;
  }
}
</style>
